import { render, staticRenderFns } from "./WorkbenchAccessore.vue?vue&type=template&id=06278f64&"
import script from "./WorkbenchAccessore.vue?vue&type=script&lang=js&"
export * from "./WorkbenchAccessore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports